import React, { useEffect, useState, useMemo } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import trLocale from 'date-fns/locale/tr';
import SearchIcon from '@material-ui/icons/Search';
import EditIcon from '@material-ui/icons/Edit';
import { sc, moneyFormat, getUser } from 'src/utils/Common';
import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
  Button,
  TextField,
  MenuItem,
  Breadcrumbs,
  Backdrop,
  CircularProgress,
  Snackbar,
  createMuiTheme,
  Checkbox,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  CardHeader,
  Chip,
  Collapse
} from '@material-ui/core';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Skeleton from '@material-ui/lab/Skeleton';
import moment from 'moment';
import axios from 'src/utils/axios';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import Alert from 'src/components/Alert';
import ExcelExport from 'src/components/ExcelExport';
import { useHistory } from 'react-router-dom';
import { maskStringData } from 'src/MaskData';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  filterCard: {
    borderRadius: 16,
    boxShadow: '0 2px 12px -4px rgba(0,0,0,.12)',
    marginBottom: theme.spacing(2)
  },
  tableCard: {
    borderRadius: 16,
    boxShadow: '0 2px 12px -4px rgba(0,0,0,.12)'
  },
  searchBtn: {
    height: 40,
    backgroundColor: '#1E5128',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#155120'
    },
    '&:disabled': {
      backgroundColor: '#9e9e9e'
    }
  },
  bulkBtn: {
    height: 40,
    backgroundColor: '#1976d2',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#115293'
    }
  },
  tableHead: {
    backgroundColor: '#f4f6f8'
  },
  headCell: {
    fontWeight: 700,
    fontSize: 12,
    letterSpacing: '.5px',
    textTransform: 'uppercase',
    color: '#546e7a',
    whiteSpace: 'nowrap'
  },
  bodyRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f9fbff !important'
    }
  },
  pageTitle: {
    fontWeight: 700,
    color: '#263238'
  },
  resultCount: {
    fontSize: 13,
    color: '#78909c',
    fontWeight: 500
  },
  cardscontent: {
    minHeight: 150
  },
  chipMaterialOrderStatus: {
    fontSize: 13,
    height: 22,
    fontWeight: 600
  }
}));

const darkColor = '#424242';
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: darkColor,
      main: darkColor,
      light: darkColor
    }
  }
});

function MaterialOrderManagement() {
  const classes = useStyles();
  const { t } = useTranslation('overview');
  const history = useHistory();
  const SessionUser = getUser();

  const localeMap = { tr: trLocale };
  const locale = localStorage.getItem('i18nextLng');

  const [statusList] = useState([
    { Id: 1, Name: t('lblNew') },
    { Id: 9, Name: t('lblPartially Delivered') },
    { Id: 10, Name: t('lblDelivered') },
    { Id: 2, Name: t('lblCanceled') },
    { Id: 11, Name: t('lblShipped') },
    { Id: 12, Name: t('lblPNA') },
    { Id: 13, Name: t('lblArranged') }

  ]);
  const [selectedStatus, setSelectedStatus] = useState({ Id: 1, Name: 'New' });

  const [statusDetailList] = useState([
    { Id: 1, Name: t('lblNew') },
    { Id: 2, Name: t('lblCancel') },
    { Id: 5, Name: t('lblDelivered') },
    { Id: 6, Name: t('lblPNA') },
    { Id: 7, Name: t('lblAwaiting') },
    { Id: 8, Name: t('lblArranged') },
  ]);
  const [selectedStatusDetail, setSelectedStatusDetail] = useState({ Id: 1, Name: 'New' });

  const [startDateSearch, setStartDateSearch] = useState(
    moment().startOf('day').add(-7, 'days').add(12, 'hours').format('YYYY-MM-DD')
  );
  const [endDateSearch, setEndDateSearch] = useState(new Date());
  const [serviceShopData, setServiceShopData] = useState([]);
  const [serviceShopInfo, setServiceShopInfo] = useState('');

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [responseType, setResponseType] = useState('success');
  const [responseDsc, setResponseDsc] = useState('');

  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [querySearchScreenData, setQuerySearchScreenData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const [selectedWorkOrderIds, setSelectedWorkOrderIds] = useState([]);
  const [checkedWorkOrderId, setCheckedWorkOrderId] = useState([]);
  const [openStatusDialog, setOpenStatusDialog] = useState(false);

  const [dialogMaterialOrderStatus, setDialogMaterialOrderStatus] = useState(null);
  const [dialogDescription, setDialogDescription] = useState('');
  
  const [isRequired, setIsRequired] = useState(false);
  const [dialogMaterials, setDialogMaterials] = useState([]);
  const [dialogWorkOrderMaterials, setDialogWorkOrderMaterials] = useState([]);
  const [dialogMismatchedMaterials, setDialogMismatchedMaterials] = useState([]);
  const [showInfoPanels, setShowInfoPanels] = useState(false);
  const handleMaterialStatusChange = (index, newStatusId) => {
    const updatedMaterials = [...dialogMaterials];
    updatedMaterials[index].SelectedStatusId = newStatusId;
    setDialogMaterials(updatedMaterials);
  };
  
  const defaultMaterialOrder = {
    workOrderId: null,
    service: SessionUser.ServiceShopName,
    orderNumber: null,
    orderDate: moment().format('YYYY-MM-DD'),
    jobNumber: '',
    poNumber: '',
    modelCode: '',
    sapNumber: '',
    status: statusList[0].Name,
    recipientName: '',
    description: '',
    statusDetail: statusDetailList[0].Name,
    recipientAddress: '',
    ServiceShopId:
      SessionUser.UserType === 1 || SessionUser.UserType === 2
        ? SessionUser.ServiceShopId
        : 0
  };
  
  const materialOrderStatusChipColor = status => {
    switch (status) {
      case 'Open':         return { backgroundColor: '#e8f5e9', color: '#2e7d32' };
      case 'Closed':       return { backgroundColor: '#fdecea', color: '#c62828' };
      case 'Completed':    return { backgroundColor: '#e8f5e9', color: '#2e7d32' };
      case 'Pending':      return { backgroundColor: '#fff3e0', color: '#e65100' };
      case 'Not Sent':     return { backgroundColor: '#fce4ec', color: '#b71c1c' };
      case 'New':          return { backgroundColor: '#eeeeee', color: '#2e7d32' };
      default:             return {};
    }
  };

  const [materialOrderData, setMaterialOrderData] = useState(defaultMaterialOrder);

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };

const getRegionZoneServiceShops = () => {
  setLoading(true);
  axios
    .get(`/GetRegionZoneServiceShops`)
    .then(response => {
      setLoading(false);
      const fetchedServiceShopData = response.data || [];
      setServiceShopData(fetchedServiceShopData);
      if (fetchedServiceShopData.length > 0) {
        setServiceShopInfo(fetchedServiceShopData[0]);
      } else {
        setServiceShopInfo(null);
      }
    })
    .catch(() => {
      setLoading(false);
      setServiceShopData([]);
      setServiceShopInfo(null);
    });
};

 useEffect(() => {
  getRegionZoneServiceShops();
}, []);

  const getMaterialOrderRequest = () => {
    if (serviceShopInfo?.ServiceShopId === undefined) return;

    setQuerySearchScreenData([]);
    setSelectedWorkOrderIds([]);
    setLoading(true);
    setHasSearched(true);

    const formattedStartDate = moment(startDateSearch).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDateSearch).format('YYYY-MM-DD');

    const requestPayload = {
      StatusId: selectedStatus.Id,
      StartDate: formattedStartDate,
      EndDate: formattedEndDate,
      ServiceShopId: serviceShopInfo?.ServiceShopId || SessionUser.ServiceShopId,  
      OrderNr: materialOrderData.orderNumber ? materialOrderData.orderNumber : null,
      SapNr: materialOrderData.sapNumber || "",
      StatusDetailId: selectedStatusDetail.Id,
      workOrderId: materialOrderData.workOrderId ? materialOrderData.workOrderId : null
    };

    axios
      .post('/GetMaterialOrderManagement', requestPayload, { headers: { 'Content-Type': 'application/json' } })
      .then(response => {
        const apiResponse = response.data;
        if (apiResponse.length > 0) {
          setQuerySearchScreenData(apiResponse);
        } else {
          setQuerySearchScreenData([]);
          setResponseType('warning');
          setResponseDsc(t('lblNoFoundOrder'));
          setOpenSnackbar(true);
        }
        setLoading(false);
      })
      .catch(() => {
        setQuerySearchScreenData([]);
        setLoading(false);
        setResponseType('error');
        setResponseDsc(t('lblError'));
        setOpenSnackbar(true);
      });
  };

  function handleRoute(row) {
    const value = querySearchScreenData.filter(x => x.MaterialOrderId === row.MaterialOrderId);
    if (history && history.push) {
      if (value[0].ShipToToConsumerId !== 0) {
        history.push({ pathname: '/materialOrder2/Create/ForConsumer', state: value[0] });
      } else if (value[0].ShipToToServiceShopId !== 0) {
        history.push({ pathname: '/materialOrder2/Create/ForPartner', state: value[0] });
      }
    }
  }

  const orderRows = useMemo(() => {
    return querySearchScreenData.map(row => {
      let orderTotal = 0;
      if (row.MaterialOrderDetails && row.MaterialOrderDetails.length > 0) {
        orderTotal = row.MaterialOrderDetails.reduce((sum, det) => sum + (det.PriceWithWat * det.Qty), 0);
      }
      return {
        ...row,
        OrderTotal: orderTotal
      };
    });
  }, [querySearchScreenData]);

  const filteredOrderRows = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) return orderRows;
    return orderRows.filter(row => {
      const formattedDate = row.OrderDate
        ? SessionUser.TenantId === 79
          ? moment(row.OrderDate).format('MM/DD/YYYY HH:mm')
          : moment(row.OrderDate).format('DD/MM/YYYY HH:mm')
        : '';
        
      return [
        row.WorkOrderId,
        row.MaterialOrderId,
        row.ConsumerFullName,
        row.SourceServiceShopCode,
        row.ServiceShopDsc,
        row.ShipTo,
        row.WorkOrderStatus,
        formattedDate
      ].some(val => val !== undefined && val !== null && String(val).toLowerCase().includes(term));
    });
  }, [orderRows, searchTerm, SessionUser.TenantId]);

  const exportData = data => {
    return data.map(row => {
      const orderTotal = row.MaterialOrderDetails 
        ? row.MaterialOrderDetails.reduce((sum, det) => sum + (det.PriceWithWat * det.Qty), 0) 
        : 0;

      return {
        [t('lblJobNumber')]: row.WorkOrderId,
        [t('lblOrderNumber')]: row.MaterialOrderId,
        [t('lblOrderDate')]: row.OrderDate === undefined
          ? ''
          : SessionUser.TenantId === 79
          ? moment(row.OrderDate).format('MM/DD/YYYY HH:mm')
          : moment(row.OrderDate).format('DD/MM/YYYY HH:mm'),
        [t('lblEmployeeName')]: row.UpdateEmployee !== " " && row.UpdateEmployee ? row.UpdateEmployee : '',
        [t('lblServiceShop')]: `${row.SourceServiceShopCode} ${row.ServiceShopDsc}`,
        [t('lblShipTo')]: row.ShipTo,
        [t('lblMaterialOrderStatus')]: row.MaterialOrderStatus,
        [t('lblWorkOrderStatus')]: row.WorkOrderStatus,
        [t('lblTotal')]: SessionUser.ServiceShopPriceVisible
          ? moneyFormat(orderTotal, SessionUser.TenantCode, SessionUser.CurrencyUnit) + ` ${SessionUser.CurrencyUnit}`
          : `0 ${SessionUser.CurrencyUnit}`
      };
    });
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const newSelected = [...new Set(filteredOrderRows.map((r) => r.WorkOrderId))];
      setSelectedWorkOrderIds(newSelected);
      return;
    }
    setSelectedWorkOrderIds([]);
  };

  const handleSelectRow = (event, workOrderId) => {
    event.stopPropagation();
    const selectedIndex = selectedWorkOrderIds.indexOf(workOrderId);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedWorkOrderIds, workOrderId);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedWorkOrderIds.slice(1));
    } else if (selectedIndex === selectedWorkOrderIds.length - 1) {
      newSelected = newSelected.concat(selectedWorkOrderIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedWorkOrderIds.slice(0, selectedIndex),
        selectedWorkOrderIds.slice(selectedIndex + 1)
      );
    }
    setSelectedWorkOrderIds(newSelected);
  };

  const handleOpenDialog = (event, workOrderIdsArray) => {
    if (event) event.stopPropagation();
    setCheckedWorkOrderId(workOrderIdsArray);

    const selectedOrders = orderRows.filter(r => workOrderIdsArray.includes(r.WorkOrderId));
    let extractedMaterials = [];
    let extractedWorkOrderMaterials = []; 
    selectedOrders.forEach(order => {
      if (order.MaterialOrderDetails && order.MaterialOrderDetails.length > 0) {
        order.MaterialOrderDetails.forEach(detail => {
          let matchedStatusId = detail.MaterialOrderDetailStatusId || detail.StatusId || statusDetailList[0].Id;
          extractedMaterials.push({
            ...detail,
            WorkOrderId: order.WorkOrderId,
            SelectedStatusId: matchedStatusId
          });
        });
      }
      if (order.WorkOrderDetails && order.WorkOrderDetails.length > 0) {
        order.WorkOrderDetails.forEach(detail => {
          extractedWorkOrderMaterials.push({
            ...detail,
            WorkOrderId: order.WorkOrderId
          });
        });
      }
    });
    
    let mismatchedMap = new Map();
    

    const orderedMap = new Map();
    extractedMaterials.forEach(m => {
      const code = m.MaterialCode;
      if (code) {
        orderedMap.set(code, (orderedMap.get(code) || 0) + (Number(m.Qty) || 0));
      }
    });

    const workOrderMap = new Map();
    extractedWorkOrderMaterials.forEach(m => {
      const code = m.MaterialCode;
      if (code) {
        workOrderMap.set(code, (workOrderMap.get(code) || 0) + (Number(m.Quantity) || 0));
      }
    });

    const allMaterialCodes = new Set([...orderedMap.keys(), ...workOrderMap.keys()]);
    let calculatedMismatches = [];

    allMaterialCodes.forEach(code => {
      const woQty = workOrderMap.get(code) || 0;
      const ordQty = orderedMap.get(code) || 0;

      if (woQty !== ordQty) {
        const sample = extractedWorkOrderMaterials.find(x => x.MaterialCode === code) || extractedMaterials.find(x => x.MaterialCode === code);
        calculatedMismatches.push({
          WorkOrderId: sample?.WorkOrderId || '-',
          MaterialCode: code,
          Material: sample?.Material || '-',
          WorkOrderQty: woQty,
          OrderedQty: ordQty,
          Difference: ordQty - woQty
        });
      }
    });
    
    setDialogMaterials(extractedMaterials);
    setDialogWorkOrderMaterials(extractedWorkOrderMaterials);
    setDialogMismatchedMaterials(calculatedMismatches);

    const initialDesc = selectedOrders.length === 1 ? (selectedOrders[0]?.Dsc || selectedOrders[0]?.Description || '') : '';
    let initialOrderStatus = null;
    
    if (selectedOrders.length === 1 &&selectedOrders[0].MaterialOrderStatusId) {
      initialOrderStatus = statusList.find(s => s.Id === selectedOrders[0].MaterialOrderStatusId) || null;
    }

    setDialogMaterialOrderStatus(initialOrderStatus);
    setDialogDescription(initialDesc);
    setIsRequired(false);
    setOpenStatusDialog(true);
    setShowInfoPanels(false);
  };

  const handleCloseDialog = () => {
    setOpenStatusDialog(false);
  };

  const handleSaveStatus = () => {
    // Form validation
    if (!dialogMaterialOrderStatus) {
      setIsRequired(true);
      return;
    }

     const payload = {
      MaterialOrderStatusId: dialogMaterialOrderStatus ? dialogMaterialOrderStatus.Id : null,
      Description: dialogDescription,
      MaterialUpdates: dialogMaterials.map(m => ({
        WorkOrderId:m.WorkOrderId,
        MaterialOrderId:m.MaterialOrderId,
        MaterialId: m.MaterialId,
        StatusId: m.SelectedStatusId
      }))
    };

    setLoading(true);

    axios
      .post('/SetMaterialOrderManagement', payload, { headers: { 'Content-Type': 'application/json' } })
      .then(response => {
        setLoading(false);
        setOpenStatusDialog(false);
        setSelectedWorkOrderIds([]);
        
        // Success notification
        setResponseType('success');
        setResponseDsc(t('lblSuccess') || 'Operation completed successfully.');
        setOpenSnackbar(true);

        // Refresh the table to reflect new statuses
        getMaterialOrderRequest();
      })
      .catch(error => {
        setLoading(false);
        
        // Error notification
        setResponseType('error');
        setResponseDsc(t('lblError') || 'An error occurred during the operation.');
        setOpenSnackbar(true);
      });
  };
  return (
    <Page className={classes.root} title={t('lblMaterialOrderManagement') || 'Material Order Management'}>
      <Container maxWidth={false}>
        <Card className={classes.filterCard}>
          <CardContent>
            <ThemeProvider theme={materialTheme}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[locale]}>
                <Grid container spacing={2} alignItems="center">
                  
                  <Grid item xs={12} sm={6} md={3} lg={2}>
                    <Autocomplete
                      size="small" fullWidth autoSelect disableClearable
                      options={serviceShopData}
                      getOptionLabel={option => option && option.SourceServiceShopCode ? `${option.SourceServiceShopCode} - ${option.Dsc}` : ''}
                      value={serviceShopInfo}
                      renderInput={params => <TextField {...params} label={t('lblServiceShop')} variant="outlined" />}
                      onChange={(event, value) => setServiceShopInfo(value)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={2} lg={1}>
                    <TextField size="small" fullWidth select label={t('lblStatus')} variant="outlined" value={selectedStatus.Id}>
                      {statusList?.map(h => (
                        <MenuItem onClick={() => setSelectedStatus(h)} key={h.Id} value={h.Id}>{h.Name}</MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={12} sm={6} md={2} lg={2}>
                    <KeyboardDatePicker
                      color="primary"
                      inputVariant="outlined"
                      size="small"
                      invalidDateMessage={t('invalidDate')}
                      format="dd.MM.yyyy"
                      fullWidth
                      label={t('startDate')}
                      value={startDateSearch}
                      onChange={e => setStartDateSearch(e)}
                      KeyboardButtonProps={{ 'aria-label': 'change date' }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={2} lg={2}>
                    <KeyboardDatePicker
                      color="primary"
                      inputVariant="outlined"
                      size="small"
                      invalidDateMessage={t('invalidDate')}
                      format="dd.MM.yyyy"
                      fullWidth
                      autoComplete="off"
                      label={t('endDate')}
                      value={endDateSearch}
                      onChange={e => setEndDateSearch(e)}
                      KeyboardButtonProps={{ 'aria-label': 'change date' }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3} lg={2}>
                    <TextField
                      size="small"
                      autoComplete="no"
                      value={materialOrderData.workOrderId || ''}
                      onChange={event => setMaterialOrderData({ ...materialOrderData, workOrderId: event.target.value })}
                      fullWidth
                      label={t('lblWorkOrderId')}
                      variant="outlined"
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3} lg={2}>
                    <TextField
                      size="small"
                      autoComplete="no"
                      value={materialOrderData.orderNumber || ''}
                      onChange={event => setMaterialOrderData({ ...materialOrderData, orderNumber: event.target.value })}
                      fullWidth
                      label={t('lblOrderNumber')}
                      variant="outlined"
                    />
                  </Grid>


                  <Grid item xs={12} sm={6} md={2} lg={1}>
                    <Button
                      fullWidth variant="contained" className={classes.searchBtn} endIcon={<SearchIcon />}
                      onClick={getMaterialOrderRequest} disabled={loading}
                    >
                      {t('search')}
                    </Button>
                  </Grid>

                </Grid>
              </MuiPickersUtilsProvider>
            </ThemeProvider>
          </CardContent>
        </Card>

        <Card className={classes.tableCard}>
          <CardContent style={{ padding: 0 }}>
            <Box display="flex" alignItems="center" justifyContent="space-between" px={2} py={1.5} borderBottom="1px solid #eceff1">
              <Box display="flex" alignItems="center" style={{ gap: 16 }}>
                <Typography variant="subtitle1" style={{ fontWeight: 700, color: '#37474f' }}>
                  {t('lblMaterialOrders') || 'Material Orders'}
                </Typography>
                
                {selectedWorkOrderIds.length > 0 && (
                  <Button
                    variant="contained"
                    size="small"
                    className={classes.bulkBtn}
                    onClick={(e) => handleOpenDialog(e, selectedWorkOrderIds)}
                  >
                    Batch Actions ({selectedWorkOrderIds.length})
                  </Button>
                )}
              </Box>

              <Box display="flex" alignItems="center" style={{ gap: 16 }}>
                <TextField
                  size="small" variant="outlined" placeholder="Search in all columns..."
                  value={searchTerm} onChange={e => setSearchTerm(e.target.value)} disabled={!hasSearched} style={{ minWidth: 260 }}
                  InputProps={{ startAdornment: <SearchIcon style={{ marginRight: 8, color: '#78909c', fontSize: 18 }} /> }}
                />
                <ExcelExport JsonData={exportData(orderRows)} />
                {hasSearched && (
                  <Typography className={classes.resultCount}>
                    {filteredOrderRows.length} record{filteredOrderRows.length !== 1 ? 's' : ''} found
                  </Typography>
                )}
              </Box>
            </Box>

            <TableContainer style={{ overflowX: 'auto' }}>
              <Table size="small" style={{ minWidth: 1000 }}>
                <TableHead className={classes.tableHead}>
                  <TableRow>
                    <TableCell padding="checkbox" className={classes.headCell}>
                      <Checkbox
                        indeterminate={selectedWorkOrderIds.length > 0 && selectedWorkOrderIds.length < [...new Set(filteredOrderRows.map(r => r.WorkOrderId))].length}
                        checked={filteredOrderRows.length > 0 && selectedWorkOrderIds.length === [...new Set(filteredOrderRows.map(r => r.WorkOrderId))].length}
                        onChange={handleSelectAll}
                      />
                    </TableCell>
                    <TableCell className={classes.headCell} align="center">Actions</TableCell>
                    
                    <TableCell className={classes.headCell} align="left">{t('lblWorkOrderId')}</TableCell>
                    <TableCell className={classes.headCell} align="left">{t('lblOrderNumber')}</TableCell>
                    <TableCell className={classes.headCell} align="left">{t('lblMaterialOrderStatus')}</TableCell>
                    <TableCell className={classes.headCell} align="left">{t('lblWorkOrderStatus')}</TableCell>
                    <TableCell className={classes.headCell} align="left">{t('lblConsumerName')}</TableCell>
                    <TableCell className={classes.headCell} align="left">{t('lblServiceShop')}</TableCell>
                    <TableCell className={classes.headCell} align="left">{t('lblOrderDate')}</TableCell>
                    <TableCell className={classes.headCell} align="left">{t('lblTotal')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!hasSearched ? (
                    <TableRow><TableCell colSpan={10} align="center" style={{ padding: 40 }}><Typography variant="body2" color="textSecondary">Please select filters and press Search.</Typography></TableCell></TableRow>
                  ) : loading ? (
                    Array.from({ length: 3 }).map((_, i) => (<TableRow key={i}>{Array.from({ length: 10 }).map((_, j) => (<TableCell key={j}><Skeleton variant="text" width="80%" /></TableCell>))}</TableRow>))
                  ) : filteredOrderRows.length === 0 ? (
                    <TableRow><TableCell colSpan={10} align="center" style={{ padding: 40 }}><Typography variant="body2" color="textSecondary">No records found for the selected filters.</Typography></TableCell></TableRow>
                  ) : (
                    filteredOrderRows.map((row, idx) => {
                      const isItemSelected = selectedWorkOrderIds.indexOf(row.WorkOrderId) !== -1;
                      
                      return (
                      <TableRow
                        key={`${row.MaterialOrderId}-${idx}`}
                        className={classes.bodyRow}
                        style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#fafbfc' }}
                        onClick={() => handleRoute(row)}
                        selected={isItemSelected}
                      >
                        <TableCell padding="checkbox" onClick={(e) => e.stopPropagation()}>
                          <Checkbox
                            checked={isItemSelected}
                            onChange={(e) => handleSelectRow(e, row.WorkOrderId)}
                          />
                        </TableCell>

                        <TableCell align="center" onClick={(e) => e.stopPropagation()}>
                          <IconButton size="small" color="primary" onClick={(e) => handleOpenDialog(e, [row.WorkOrderId])}>
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </TableCell>

                        <TableCell align="left" style={{ fontWeight: 600, color: '#1565c0' }}>{row.WorkOrderId}</TableCell>
                        <TableCell align="left">{row.MaterialOrderId}</TableCell>
                        <TableCell align="left">
                            <Chip
                            label={row.MaterialOrderStatus}
                            size="small"
                            className={classes.chipMaterialOrderStatus}
                            style={materialOrderStatusChipColor(row.MaterialOrderStatus)}
                            />
                        </TableCell>
                         <TableCell align="left">
                            <Chip
                            label={row.WorkOrderStatus}
                            size="small"
                            className={classes.chipMaterialOrderStatus}
                            />
                        </TableCell>
                        <TableCell align="left">
                          {row.UpdateEmployee !== " " && row.UpdateEmployee ? row.UpdateEmployee : ''}
                        </TableCell>
                        <TableCell align="left">{`${row.SourceServiceShopCode} ${row.ServiceShopDsc}`}</TableCell>
                        <TableCell align="left">
                          {row.OrderDate === undefined
                            ? ''
                            : SessionUser.TenantId === 79
                            ? moment(row.OrderDate).format('MM/DD/YYYY HH:mm')
                            : moment(row.OrderDate).format('DD/MM/YYYY HH:mm')}
                        </TableCell>
                        <TableCell align="left">
                          {SessionUser.ServiceShopPriceVisible
                            ? moneyFormat(row.OrderTotal, SessionUser.TenantCode, SessionUser.CurrencyUnit)
                            : 0}
                          {`${SessionUser.CurrencyUnit}`}
                        </TableCell>
                      </TableRow>
                    )})
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Container>

      <Dialog
        open={openStatusDialog}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle disableTypography>
          <Typography variant="h6">{t('lblChangeMaterialOrderStatus') || 'Change Status'}</Typography>
        </DialogTitle>
        <DialogContent dividers style={{ padding: 0 }}>
          <Container maxWidth="xl" style={{ padding: '16px' }}>
            <Card variant="outlined">
              <CardHeader title={`${t('lblWorkOrderId') || 'Work Order ID'}: ${checkedWorkOrderId?.join(', ')}`} />
              <Divider />
              <CardContent className={classes.cardscontent}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} lg={12}>
                    <Autocomplete
                      size="small"
                      fullWidth
                      autoSelect
                      value={dialogMaterialOrderStatus || null}
                      options={statusList || []}
                      getOptionLabel={(option) => (option.Name ? option.Name : '')}
                      getOptionSelected={(option, value) => option.Id === value.Id}
                      renderInput={(params) => (
                        <TextField 
                          {...params} 
                          label={t('lblMaterialOrderStatus') || 'Material Order Status'} 
                          variant="outlined" 
                          error={isRequired && !dialogMaterialOrderStatus} 
                        />
                      )}
                      onChange={(event, value) => {
                        setDialogMaterialOrderStatus(value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} lg={12}>
                    <TextField
                      size="small"
                      id="Description"
                      multiline
                      rows={4}
                      autoComplete="no"
                      fullWidth
                      label={t('lblDescription') || 'Description'}
                      variant="outlined"
                      value={dialogDescription}
                      onChange={(event) => setDialogDescription(event.target.value)}
                    />
                  </Grid>

                  {dialogMaterials && dialogMaterials.length > 0 && (
                    <Grid item xs={12} sm={12} lg={12}>
                      <Typography variant="subtitle2" style={{ marginTop: 8, marginBottom: 8, fontWeight: 700, color: '#37474f' }}>
                        {t('lblMaterialDetails') || 'Material Details'}
                      </Typography>
                      <TableContainer style={{ border: '1px solid #eceff1', borderRadius: 4 }}>
                        <Table size="small">
                          <TableHead className={classes.tableHead}>
                            <TableRow>
                              <TableCell className={classes.headCell}>WorkOrder Id</TableCell>
                              <TableCell className={classes.headCell}>Order Id</TableCell>
                              <TableCell className={classes.headCell}>Code</TableCell>
                              <TableCell className={classes.headCell}>Spare Part</TableCell>
                              <TableCell className={classes.headCell} align="center">Quantity</TableCell>
                              <TableCell className={classes.headCell} style={{ width: 220 }}>Spare Part Status</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {dialogMaterials.map((detail, index) => (
                              <TableRow key={index} className={classes.bodyRow}>
                                <TableCell style={{ fontWeight: 500 }}>{detail.WorkOrderId  || '-'}</TableCell>
                                <TableCell style={{ fontWeight: 500 }}>{detail.MaterialOrderId  || '-'}</TableCell>
                                <TableCell>
                                  {detail.MaterialCode || '-'}
                                </TableCell>
                                <TableCell style={{ fontWeight: 500 }}>{detail.Material  || '-'}</TableCell>
                                <TableCell align="center">{detail.Qty}</TableCell>
                                <TableCell>
                                  <TextField
                                    size="small"
                                    select
                                    fullWidth
                                    variant="outlined"
                                    value={detail.SelectedStatusId || ''}
                                    onChange={(e) => handleMaterialStatusChange(index, e.target.value)}
                                  >
                                    {statusDetailList?.map(s => (
                                      <MenuItem key={s.Id} value={s.Id}>{s.Name}</MenuItem>
                                    ))}
                                  </TextField>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                  )}
                  {/* INFORMATIVE PANEL: UYARI BARI VE GİZLENEBİLİR TABLOLAR */}
                  {(dialogWorkOrderMaterials.length > 0 || dialogMismatchedMaterials.length > 0) && (
                    <Grid item xs={12} sm={12} lg={12}>
                      <Box 
                        display="flex" 
                        justifyContent="space-between" 
                        alignItems="center" 
                        p={1.5} 
                        borderRadius={4} 
                        border={dialogMismatchedMaterials.length > 0 ? '1px solid #ffccbc' : '1px solid #e0e0e0'}
                        bgcolor={dialogMismatchedMaterials.length > 0 ? '#fffbe6' : '#f5f5f5'}
                      >
                        <Typography 
                          variant="body2" 
                          style={{ fontWeight: 600, color: dialogMismatchedMaterials.length > 0 ? '#c62828' : '#424242' }}
                        >
                          {dialogMismatchedMaterials.length > 0
                            ? t('lblMismatchedMaterialsWarning', '⚠️ Material quantity differences detected between the work order and the order.')
                            : t('lblWorkOrderMaterialDetailsInfo', 'ℹ️ You can view the work order material details.')}
                        </Typography>
                        <Button 
                          size="small" 
                          variant="outlined" 
                          color={dialogMismatchedMaterials.length > 0 ? 'secondary' : 'default'}
                          onClick={() => setShowInfoPanels(!showInfoPanels)}
                        >
                          {showInfoPanels ? t('lblHideDetails', 'Hide') : t('lblShowDetails', 'Show')}
                        </Button>
                      </Box>

                      <Collapse in={showInfoPanels}>
                        <Box mt={2} p={2} border="1px dashed #cfd8dc" borderRadius={4}>

                          {dialogMismatchedMaterials && dialogMismatchedMaterials.length > 0 && (
                            <Box mb={3}>
                              <Typography variant="subtitle2" style={{ marginBottom: 8, fontWeight: 700, color: '#c62828' }}>
                                {t('lblMismatchedMaterials') || 'Eşleşmeyen Malzemeler (Mismatched Materials)'}
                              </Typography>
                              <TableContainer style={{ border: '1px solid #ffccbc', backgroundColor: '#fffbe6', borderRadius: 4 }}>
                                <Table size="small">
                                  <TableHead style={{ backgroundColor: '#fff3cd' }}>
                                    <TableRow>
                                      <TableCell className={classes.headCell}>WorkOrder Id</TableCell>
                                      <TableCell className={classes.headCell}>Code</TableCell>
                                      <TableCell className={classes.headCell}>Material</TableCell>
                                      <TableCell className={classes.headCell} align="center">WorkOrder Qty</TableCell>
                                      <TableCell className={classes.headCell} align="center">Ordered Qty</TableCell>
                                      <TableCell className={classes.headCell} align="center">Difference</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {dialogMismatchedMaterials.map((item, index) => (
                                      <TableRow key={index} className={classes.bodyRow}>
                                        <TableCell style={{ fontWeight: 500 }}>{item.WorkOrderId || '-'}</TableCell>
                                        <TableCell>{item.MaterialCode || '-'}</TableCell>
                                        <TableCell style={{ fontWeight: 500 }}>{item.Material || '-'}</TableCell>
                                        <TableCell align="center">{item.WorkOrderQty}</TableCell>
                                        <TableCell align="center">{item.OrderedQty}</TableCell>
                                        <TableCell align="center" style={{ fontWeight: 700, color: item.Difference < 0 ? '#c62828' : '#2e7d32' }}>
                                          {item.Difference > 0 ? `+${item.Difference}` : item.Difference}
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Box>
                          )}

                          {dialogWorkOrderMaterials && dialogWorkOrderMaterials.length > 0 && (
                            <Box>
                              <Typography variant="subtitle2" style={{ marginBottom: 8, fontWeight: 700, color: '#37474f' }}>
                                {t('lblWorkOrderDetails') || 'Work Order Materials'}
                              </Typography>
                              <TableContainer style={{ border: '1px solid #eceff1', borderRadius: 4 }}>
                                <Table size="small">
                                  <TableHead className={classes.tableHead}>
                                    <TableRow>
                                      <TableCell className={classes.headCell}>WorkOrder Id</TableCell>
                                      <TableCell className={classes.headCell}>Code</TableCell>
                                      <TableCell className={classes.headCell}>Material</TableCell>
                                      <TableCell className={classes.headCell} align="center">Quantity</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {dialogWorkOrderMaterials.map((detail, index) => (
                                      <TableRow key={index} className={classes.bodyRow}>
                                        <TableCell style={{ fontWeight: 500 }}>{detail.WorkOrderId || '-'}</TableCell>
                                        <TableCell>{detail.MaterialCode || '-'}</TableCell>
                                        <TableCell style={{ fontWeight: 500 }}>{detail.Material || '-'}</TableCell>
                                        <TableCell align="center">{detail.Quantity || '-'}</TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Box>
                          )}
                          
                        </Box>
                      </Collapse>
                    </Grid>
                  )}
                </Grid>
              </CardContent>
            </Card>
          </Container>
        </DialogContent>
        <DialogActions style={{ padding: '16px' }}>
          <Button onClick={handleCloseDialog} color="default" variant="outlined">
            {t('lblCancel') || 'Cancel'}
          </Button>
          <Button onClick={handleSaveStatus} color="primary" variant="contained">
            {t('lblSave') || 'Save'}
          </Button>
        </DialogActions>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar open={openSnackbar} autoHideDuration={3000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} message={responseDsc} variant={responseType} />
      </Snackbar>
    </Page>
  );
}

export default MaterialOrderManagement;